<p-dropdown
    class="w-100"
    styleClass="w-100"
    inputStyleClass="w-100"
    appendTo="body"
    dataKey="editionId"
    optionLabel="description"
    [filter]="showFilter"
    filterBy="description"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [options]="editions"
    [(ngModel)]="selected"
    (ngModelChange)="onSelectionChange()">
</p-dropdown>

